import { useParams, Navigate } from "react-router-dom";
import CityPage from "./CityPage";
import ProvincePage from "./ProvincePage";
import ServiceCityPage from "./ServiceCityPage";
import ServiceProvincePage from "./ServiceProvincePage";
import NotFound from "./NotFound";
import { resolveFlatSlug } from "../seo/routes";

const LEGACY = {
  "manned-guarding": "/services/uniformed-security-guards",
  "security-guard-training": "/careers",
  "careers-1": "/careers",
  "thunder-bay": "/security-guards-thunder-bay",
  "northwest-territories": "/security-guards-northwest-territories",
};

export default function FlatResolver() {
  const { slug } = useParams();
  const clean = slug || "";
  if (LEGACY[clean]) return <Navigate to={LEGACY[clean]} replace />;
  const resolved = resolveFlatSlug(clean);
  if (!resolved) return <NotFound />;
  if (resolved.kind === "city") return <CityPage city={resolved.city} province={resolved.province} />;
  if (resolved.kind === "province") return <ProvincePage province={resolved.province} />;
  if (resolved.kind === "serviceProvince") return <ServiceProvincePage service={resolved.service} province={resolved.province} />;
  return <ServiceCityPage service={resolved.service} city={resolved.city} province={resolved.province} />;
}
